export default function getInitState() {
    return {
        gridIsOpen: true,
        formIsOpen: false,
        ehrFormIsOpen: false,

        tableAdditionalConfig: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actionsReadOnly: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új egyéb vizsgálati dokumentum',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newLab'
            }
        ],
        rowActionsReadOnly: [
            {
                btn_text: '<i class="fas fa-file-download"></i>',
                title: 'Letöltés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'downloadLabDocument'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow',
                additionalButtonVisible: "richterReadyStatus"
            },
            {
                btn_text: '<i class="fas fa-file-download"></i>',
                title: 'Letöltés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'downloadLabDocument'
            },
            {
                btn_text: '<i class="fas fa-share-square"></i>',
                title: 'Kiküldés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'sendLabDocument',
            },
            // { //Késöbb lehet használni kell
            //     btn_text: '<i class="fas fa-plus"></i> Egészségügyi dokumentum',
            //     title: 'Rögzítés EESZT-be',
            //     event_name: "customClick",
            //     class: "btn btn-outline-primary",
            //     event_payload: 'showSendEHR',
            //     additionalButtonVisible: "isShowSendEHR"
            // },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteLab',
                additionalButtonVisible: "richterReadyStatus"
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        additionalExaminationPatientRowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showAdditionalExaminationDetails'
            },
        ],
        additionalExaminationHeaderFields: [
            {
                name: "doctor.fullName",
                label: "Orvos",
                visibility: true
            },

            {
                name: "createdBy",
                label: "Létrehozó",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Létrehozás dátuma",
                visibility: true,
                slot_name: "startDate_format"
            },
            {
                name: "dateOfExpiration",
                label: "Lejárat dátuma",
                slot_name: "expiration_date_format_color",
                visibility: true
            },
            {
                name: "labType.name",
                label: "Lelet típus",
                visibility: true
            },
            {
                name: "hierarchyName",
                label: "Munkaviszony",
                visibility: true
            },
            {
                name: "commentPreview",
                label: "Megjegyzés",
                visibility: true
            },
            {
                name: "isOccupationHealth",
                label: "FEÜ",
                slot_name: "isForpackageFormat",
                visibility: true
            },
            {
                name: "status",
                label: "Státusz",
                visibility: true
            },
            {
                label: "Opciók",
                name: "buttons",
                sort: false
            }
        ],
        additionalExaminationPatientHeaderFields: [
            {
                name: "name",
                label: "Név",
                visibility: true
            },
            {
                name: 'email',
                label: 'E-mail',
                visibility: true
            },
            {
                name: 'socialInsuranceNumber',
                label: 'TAJ',
                visibility: true
            },
            {
                name: "prefixedId",
                label: "Technikai azonosító",
                visibility: true
            },
            {
                name: 'phoneNumber',
                label: 'Telefonszám',
                visibility: true
            },
            {
                name: 'dateOfBirth',
                label: 'Születési idő',
                slot_name: "dateOfBirth_format",
                visibility: true
            },
            {
                label: "Opciók",
                name: "buttons",
                sort: false
            }
        ],
        patientFields: [
            {
                name: "familyName",
                label: "Vezetéknév",
                formType: "text",
                formSize: 4,
                formVisible: true,
                formReadOnly: true
            },
            {
                name: "firstName",
                label: "Keresztnév",
                formType: "text",
                formSize: 4,
                formVisible: true,
                formReadOnly: true
            },
            {
                name: 'email',
                label: 'E-mail',
                enableCopy: true,
                formType: 'email',
                formSize: 4,
                formVisible: true,
                formReadOnly: true
            },
            {
                name: 'socialInsuranceNumber',
                label: 'TAJ',
                enableCopy: true,
                formType: 'text',
                formSize: 4,
                formVisible: true,
                formReadOnly: true
            },
            {
                name: 'phoneNumber',
                label: 'Telefonszám',
                enableCopy: true,
                formType: 'text',
                formSize: 4,
                formVisible: true,
                formReadOnly: true
            },
            {
                name: 'dateOfBirth',
                label: 'Születési idő',
                formType: 'date',
                formSize: 4,
                formVisible: true,
                formReadOnly: true
            }
        ]
    }
}
